const mixin = {
  methods: {
    getFileGuid (file) {
      return file.id || `${file.name}${file.size}`
    }
  }
}


export default mixin
